// src/api/userApi.js
import apiClient from './apiConfig';
import Helpers from '@utils/Helpers'

interface TloginPayload {
    email: string,
    password: string
}

interface TRegisterPayload {
    email: string,
    password: string,
    phone: string,
    firstName: string,
    lastName: string,
}

interface TVerifyOTPPayload {
    email: string,
    otp: string
}

const authenticateApi = {
    Register: (data: TRegisterPayload) => {
        return apiClient.post('/register/', data);
    },
    VerifyOTP: (data: TVerifyOTPPayload) => {
        return apiClient.post('/verify/otp/', data)
    },
    Login: (data: TloginPayload) => {
        return apiClient.post('/login/', data)
    },
    GoogleLogin: (credential: any) => {
        return apiClient.post('/google/login/', credential)
    },
    GenerateAccessToken: () => {
        return apiClient.get(`/token/refresh/${Helpers.getRefreshToken}`,)
    },
    UploadImageToS3: (body: any) => {
        return apiClient.post('/s3/upload', body, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
    },
    DeleteImageFromS3: (url: string) => {
        return apiClient.delete(`/s3/delete-avatar?avatar_url=${url}`)
    },
};

export default authenticateApi;
